module.exports = __webpack_public_path__ + "static/photo-95c4a6d767c6f4cee364ff29580c9468.jpg";